import { format } from 'date-fns'

enum TimePrecision {
    MINUTES,
    SECONDS,
    MILLISECONDS,
}

const getFormat = (timePrecision: TimePrecision): string => {
    switch (timePrecision) {
        case TimePrecision.MINUTES:
            return 'dd/MM/yyyy HH:mm'
        case TimePrecision.SECONDS:
            return 'dd/MM/yyyy HH:mm:ss'
        case TimePrecision.MILLISECONDS:
            return 'dd/MM/yyyy HH:mm:ss.SSS'
    }
}

export const formatDateString = (dateString: string | undefined, timePrecision = TimePrecision.MINUTES): string => {
    if (!dateString) return ''

    const date = new Date(dateString)
    return formatDate(date, timePrecision)
}

export const formatDate = (date: Date | undefined, timePrecision = TimePrecision.MINUTES): string => {
    if (!date) return ''

    return format(date, getFormat(timePrecision))
}
